import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAllAggregatorTransactions = async ({
  pageNumber,
  size,
  startDate,
  endDate,
  aggregatorId,
  referenceNumber,
}) => {
  let queryParams = `?Page=${pageNumber}&PageSize=${size}`;

  if (startDate) {
    queryParams = `${queryParams}&FromDate=${startDate}`;
  }
  if (endDate) {
    queryParams = `${queryParams}&ToDate=${endDate}`;
  }
  if (aggregatorId) {
    queryParams = `${queryParams}&AggregatorId=${aggregatorId}`;
  }
  if (referenceNumber) {
    queryParams = `${queryParams}&ReferenceNumber=${referenceNumber}`;
  }
  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GET_AGGREGATOR_INVESMENT_TRANSACTIONS}${queryParams}`
  );

  return data;
};

export default function useAllAggregatorTransactions({
  pageNumber,
  size,
  startDate,
  endDate,
  aggregatorId,
  referenceNumber,
}) {
  return useQuery(
    [
      {
        pageNumber,
        size,
        startDate,
        endDate,
        aggregatorId,
        referenceNumber,
      },
      "getAllAggregatorTransactions",
    ],
    getAllAggregatorTransactions
  );
}
